<template>
  <v-toolbar-title>
    <slot></slot>
  </v-toolbar-title>
</template>

<script>
export default {
  name: "AppToolbarTitle",
};
</script>

<style scoped></style>
